import { CommerceService } from "@/services/commerce"

export const queryCommerce = {
  async commerce(parent, args, context, info) {
    const commerceApi = CommerceService.api()

    const projectData = (await commerceApi.get().execute()).body

    return projectData
  },
}
